/* @flow */
import type { Action } from "../action";

import {
  REGISTER_TAB_ID,
  LOGIN_TAB_ID,
  PASSWORD_RESTORE_TAB_ID,
  SOCIAL_REGISTER_TAB_ID,
  SOCIAL_PASSWORD_TAB_ID
} from "../../components/Auth/Auth";

type State = {
  displayForm: boolean,
  displayTab: string
};

const signUpParam = /^#signup/.test(window.location.hash);

const initialState = {
  displayForm: false,
  displayTab: signUpParam ? REGISTER_TAB_ID : LOGIN_TAB_ID
};

function displayTab(state, payload) {
  switch (payload) {
    case REGISTER_TAB_ID:
    case LOGIN_TAB_ID:
    case PASSWORD_RESTORE_TAB_ID:
    case SOCIAL_REGISTER_TAB_ID:
    case SOCIAL_PASSWORD_TAB_ID:
      return { ...state, displayTab: payload };
    default:
      return state;
  }
}

function displayForm(state, payload: boolean) {
  return {
    ...state,
    displayForm: !!payload
  };
}

function authForm(state: State = initialState, action: Action): State {
  switch (action.type) {
    case "DISPLAY_AUTH_TAB":
      return displayTab(state, action.payload);
    case "DISPLAY_AUTH_FORM":
      return displayForm(state, action.payload);
    default:
      return state;
  }
}

export default authForm;



// WEBPACK FOOTER //
// ./src/redux/reducer/authForm.js